"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogsType = exports.LogSeverity = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["OFF"] = 0] = "OFF";
    LogLevel[LogLevel["TRACE"] = 1] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 2] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["LOG"] = 4] = "LOG";
    LogLevel[LogLevel["WARN"] = 5] = "WARN";
    LogLevel[LogLevel["ERROR"] = 6] = "ERROR";
    LogLevel[LogLevel["FATAL"] = 7] = "FATAL";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
exports.LogSeverity = {
    [LogLevel.OFF]: 'Off',
    [LogLevel.DEBUG]: 'Debug',
    [LogLevel.INFO]: 'Info',
    [LogLevel.TRACE]: 'Info',
    [LogLevel.LOG]: 'Info',
    [LogLevel.WARN]: 'Warning',
    [LogLevel.ERROR]: 'Error',
    [LogLevel.FATAL]: 'Critical',
};
exports.LogsType = {
    [LogLevel.OFF]: 'debug',
    [LogLevel.DEBUG]: 'debug',
    [LogLevel.INFO]: 'info',
    [LogLevel.TRACE]: 'log',
    [LogLevel.LOG]: 'log',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error',
    [LogLevel.FATAL]: 'error',
};
